
import { Headers, Http, Response, ResponseContentType, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { EimsDocument } from '../../../civil/civil-case-sections/eims-document';
import { environment } from './../../../../environments/environment';

@Injectable()
export class DocumentsService {

  readonly isDummy = true;
  private headers = new Headers({ 'Content-Type': 'application/json' });

  // TODO: use HttpClient
  constructor(private http: Http) { }

  public getDocumentList(county: string, caseNumber: string): Observable<any[]> {

    const link = environment.estateBaseUrl + '/documents/' + county + '/' + caseNumber;

    if (this.isDummy) {
      return this.getMockDocumentList(county, caseNumber);
    } else {
      return this.http.get(link)
        .map((response: Response) => response.json().data)
        // .map((response: Response) => response.json())
       .catch((error) => this.handleError(error));
    }
  }

  public getDocument(county: string, caseNumber: string, documentId: string): Observable<string> {

    const link = environment.estateBaseUrl + '/documents/' + county + '/' + caseNumber + '/' + documentId;

    if (this.isDummy) {
      return this.getMockDocument();
    } else {
      return this.http.get(link)
        .map((response: Response) => {
          if (response.json().links) {
            return response.json().links[0].href;
          } else {
            return '';
          }
        })
        .catch((error) => this.handleError(error));
      }
  }

  private getMockDocument(): Observable<string> { // TODO: look at type
    return new Observable<string>(observer => {
      setTimeout(() => {
        observer.next(
          'http://www.nccourts.org/Forms/Documents/405.pdf'
        );
      }, 1000);
    });
  }

  private getMockDocumentList(county: string, caseNumber: string): Observable<any[]> { // TODO: look at type
    return new Observable<any[]>(observer => {
      setTimeout(() => {
        if (['4', '6', '8'].indexOf(caseNumber.split('').pop()) >= 0) {
          observer.next(
            [{
              createdOnTimestamp: '2017-10-12 14:25:19.000000',
              createdBy: 'admin',
              documentTitle: 'LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON',
              documentDescription: 'L1',
              documentName: 'LEE_2017E700214_AOC-E-408_Rev 4428_LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON-1.pdf',
              updatedBy: 'admin',
              updatedOnTimestamp: '2017-10-12 14:25:19.000000',
              objectId: 'b03e4da9-de14-410d-95ae-57268e434ffa',
              clockDate: '2017-10-10',
              documentHavingPII: false,
              documentPublic: true,
              documentSealed: false,
              systemGenerated: false,
              links: [{
                rel: 'self',
               href: 'https://dev.nccourts.org/estates_web_ws_1_2_0/rest/documents'
              }]
            },
            {
              createdOnTimestamp: '2017-10-12 14:23:00.000000',
              createdBy: 'admin',
              documentTitle: 'LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON',
              documentDescription: 'L2',
              documentName: 'LEE_2017E700214_AOC-E-408_Rev 4428_LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON.pdf',
              updatedBy: 'admin',
              updatedOnTimestamp: '2017-10-12 14:25:31.000000',
              objectId: 'c035680b-28c0-442c-b38d-569b41dbe5c7',
              clockDate: '2017-10-01',
              documentHavingPII: true,
              documentPublic: false,
              documentSealed: false,
              systemGenerated: false,
              links: [{
                rel: 'self',
                href: 'https://dev.nccourts.org/estates_web_ws_1_2_0/rest/documents'
              }]
            },
            {
              createdOnTimestamp: '2017-10-12 14:23:00.000000',
              createdBy: 'admin',
              documentTitle: 'LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON',
              documentDescription: 'L3',
              documentName: 'LEE_2017E700214_AOC-E-408_Rev 4428_LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON.pdf',
              updatedBy: 'admin',
              updatedOnTimestamp: '2017-10-12 14:25:31.000000',
              objectId: 'c035680b-28c0-442c-b38d-569b41dbe5c7',
              clockDate: '2017-10-05',
              documentHavingPII: true,
              documentPublic: false,
              documentSealed: true,
              systemGenerated: false,
              links: [{
                rel: 'self',
                href: 'https://dev.nccourts.org/estates_web_ws_1_2_0/rest/documents'
              }]
            }]
          );
        } else if (['9'].indexOf(caseNumber.split('').pop()) >= 0) {
          let list = new Array(30);
          list.fill({
              createdOnTimestamp: '2017-10-12 14:25:19.000000',
              createdBy: 'admin',
              documentTitle: 'LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON',
              documentDescription: 'L1',
              documentName: 'LEE_2017E700214_AOC-E-408_Rev 4428_LETTERS OF APPOINTMENT GUARDIAN OF THE PERSON-1.pdf',
              updatedBy: 'admin',
              updatedOnTimestamp: '2017-10-12 14:25:19.000000',
              objectId: 'b03e4da9-de14-410d-95ae-57268e434ffa',
              clockDate: '2017-10-10',
              documentHavingPII: false,
              documentPublic: true,
              documentSealed: false,
              systemGenerated: false,
              links: [{
                rel: 'self',
               href: 'https://dev.nccourts.org/estates_web_ws_1_2_0/rest/documents'
              }]
            });
          //console.log(list);
          observer.next(
              list
            );
          } else {
          observer.next(
            []
          );
        }
        ;
      }, 1000);
    });
  }

  public getDisplayDocumentTitle(documentType: EimsDocument): string {

    let documentNameMatch =
        documentType.
          documentName.
          match(/^([A-Za-z]*_)?((?:\d{2})?\d\d[A-Z]*\d+_)?([^-_]*)?[-]?([^-_.]*)?[-]?([^-_.]*)?[^-]*[-]?([^-_ .]*)?.*$/);

    let displayDocumentName =  documentNameMatch[3] === 'OTHER'  ?
                        documentNameMatch[3] :
                     ( documentNameMatch[3] === 'AOC' ?
                       ( documentNameMatch[4] ? documentNameMatch[4] : '')
                     + (documentNameMatch[5] ? '-' + documentNameMatch[5] : '') :
                       (documentNameMatch[3] ? documentNameMatch[3] : '')
                             + (documentNameMatch[4] ? '-' + documentNameMatch[4] : '')
                      );

    let documentTitle = documentType.documentTitle ? (documentType.documentTitle.length > 100 ?
                                    documentType.documentTitle.substring(0, 100) + '...'  :
                                    documentType.documentTitle) : documentType.documentTitle;
    return (displayDocumentName ? displayDocumentName : '')
          + (documentTitle && (displayDocumentName !== 'OTHER') ? ' - ' + documentTitle : '');
  }

  private handleError(error: any) {
    // TODO: if this error handling is consistent across all http calls,
    // we can push this code to CiprsHttp and avoid repeating the logic
    let errorMessage: string;
    if (error.status === 0) {
      // TODO: what should the user be directed to do?
      errorMessage = 'Unable to reach the server. Please try again later.';
    } else {
      const wrappedErrorResponse = error.json() || {};
      if (wrappedErrorResponse.responseCode === 404) {
        errorMessage = 'No matching records were found.';
      } else {
        errorMessage = 'The server encountered an error'; // TODO: what should the user be directed to do?
      }
    }
    console.log('errorMessage=' + errorMessage);
    return Observable.throw(errorMessage);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/documents/documents.service.ts